import React from 'react';

export default () => <h3>Sorry, page not found!</h3>;
